<template>
  <el-dialog
    append-to-body
    width="600px"
    :title="isChange ? '发放报酬修改' : '发放报酬'"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <!-- 打款信息 -->
    <el-form
      ref="formRef"
      class="rechargeForm"
      label-width="100px"
      size="small"
      :model="form"
      :rules="rules"
    >
      <el-form-item label="收款人" prop="name">
        <el-input
          clearable
          v-model.trim="form.name"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input
          clearable
          v-model.trim="form.phone"
          placeholder="请输入"
          maxlength="50"
        ></el-input>
      </el-form-item>
      <el-form-item label="工作单位" prop="work_company">
        <el-select v-model="form.work_company" placeholder="请选择" clearable filterable>
          <el-option
            v-for="item in companyOption"
            :key="item.company_name"
            :label="item.company_name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="发放单位" prop="company_name">
        <el-input
          clearable
          v-model.trim="form.company_name"
          placeholder="请输入"
          maxlength="50"
        ></el-input>
      </el-form-item>
      <el-form-item label="结算开始日" prop="start_time">
        <el-date-picker
          v-model="form.start_time"
          type="date"
          placeholder="请选择"
          value-format="yyyy-MM-dd"
          style="width: 100%"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="结算截止日" prop="end_time">
        <el-date-picker
          v-model="form.end_time"
          type="date"
          placeholder="请选择"
          value-format="yyyy-MM-dd"
          style="width: 100%"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="共计工时" prop="hour">
        <el-input
          clearable
          v-model.trim="form.hour"
          placeholder="请输入"
          maxlength="50"
        >
          <template slot="suffix">小时</template>
        </el-input>
      </el-form-item>
      <el-form-item label="结算金额" prop="amount">
        <el-input
          clearable
          v-model.trim="form.amount"
          placeholder="请输入"
          maxlength="50"
        >
          <template slot="suffix">元</template>
        </el-input>
      </el-form-item>
    </el-form>

    <template slot="footer">
      <el-row type="flex" justify="center">
        <el-button
          class="theneBtn"
          type="primary"
          :loading="loading"
          :disabled="loading"
          @click="confirm"
          >确 定</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      loading: false,
      info: {},
      companyOption:[],
      isChange: false,
      form: {
        name: "",
        phone: "",
        work_company: "",
        company_name: "",
        start_time: "",
        end_time: "",
        hour: "",
        amount: "",
      },
      rules: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        phone: [{ required: true, message: "请输入", trigger: "blur" }],
        work_company: [{ required: true, message: "请输入", trigger: "blur" }],
        company_name: [{ required: true, message: "请输入", trigger: "blur" }],
        start_time: [{ required: true, message: "请选择", trigger: "blur" }],
        end_time: [{ required: true, message: "请选择", trigger: "blur" }],
        hour: [{ required: true, message: "请输入", trigger: "blur" }],
        amount: [{ required: true, message: "请输入", trigger: "blur" }],
      },
    };
  },
  methods: {
    // 获取收款信息
    getDetail(info) {
      this.info = info || {};
      this.getCompanyOption();
      if (info.id) {
        this.isChange = true;
        this.form = {
          ...info,
        };
      }
    },
    getCompanyOption() {
      this.$http
        .get("/admin/flex_salary/company",{ params: {} }).then(res =>{
          if(res.code == 1){
            this.companyOption = res.data.list;
          }
        })
    },
    // 提交充值申请
    confirm() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        let params = {
          ...this.form,
        };
        if (this.isChange) {
          params.id = this.info.id;
        }
        this.$http
          .post("/admin/flex_send/createOrUpdate", params)
          .then((res) => {
            if (res.code === 1) {
              this.$message.success("操作成功");
              this.$emit("success");
              this.toggle(false);
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    reset(done) {
      this.loading = false;
      this.isChange = false;
      this.info = {};
      this.form = {
        name: "",
        phone: "",
        work_company: "",
        company_name: "",
        start_time: "",
        end_time: "",
        hour: "",
        amount: "",
      };
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
.payType__wrap {
  display: flex;
  margin-bottom: 16px;

  .payType__item {
    position: relative;
    flex: 1;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    color: #606266;
    cursor: pointer;
    transition: all 0.2s;

    & + .payType__item {
      margin-left: 12px;
    }

    i {
      margin-right: 6px;
      font-size: 18px;
    }

    .check__icon {
      margin: 0 0 0 6px;
      font-size: 16px;
    }

    &:hover {
      border-color: $theme;
      color: $theme;
    }

    &.active {
      border-color: $theme;
      color: $theme;
      background-color: #e6f1fd;
    }
  }
}

.payInfo__wrap {
  padding: 12px 16px;
  margin-bottom: 16px;
  background-color: #fafafa;
  border-radius: 4px;

  .payInfo__row {
    font-size: 14px;
    line-height: 28px;
    color: #606266;
    word-break: break-all;
  }

  .payInfo__tip {
    font-size: 13px;
    color: #909399;
  }
}

.qrcode__wrap {
  margin: 8px 0;

  img {
    width: 150px;
    height: 150px;
    display: block;
    border: 1px solid #ebeef5;
    background-color: #fff;
    object-fit: contain;
  }

  .qrcode__placeholder {
    width: 150px;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #dcdfe6;
    background-color: #fff;
    color: #c0c4cc;
    font-size: 13px;
  }
}

.rechargeForm {
  margin-top: 4px;
}
</style>
